//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.CollisionShapeBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ActiveStatusColor",1,0],[0,"ButtonType",1,0],[1,"Geometry",0,"SelectNXObjectList",0],[0,"InactiveStatusColor",1,0],[0,"InitialValue",1,0],[0,"Name",1,0],[0,"OverrideActiveStatusColor",1,0],[0,"OverrideInactiveStatusColor",1,0]],[[["geometries"],"SetGeometry",{},1,0]],[]];
SPLM.Mechatronics.RuntimeButtonBuilder = class extends SPLM.Mechatronics.CollisionShapeBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.RuntimeButtonBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.RuntimeButtonBuilder.ButtonTypes = Object.freeze({
    "Trigger" : "Trigger", "Switcher" : "Switcher"});

SPLM.Mechatronics.RuntimeButtonBuilder.InitialValues = Object.freeze({
    "True" : "True", "False" : "False"});

export default SPLM;